export const itemLink = (link, title, thumbSrc, type ='' ) => `
<div class="event-item card accent dark size-xl football ${type}">
    <a class="thumb-cont" href="${link}" title="${title}">
        <picture>
            <img loading="lazy" src="${thumbSrc}" alt="${title}">
        </picture>
    </a>
    <div class="info-cont">
        <h3 class="title"><a href="${link}" title="${title}" >${title}</a></h3>
    </div>
</div>`;